import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTOGRAPHY_STATUS } from 'domains/merchant-product/constants'

const propTypes = {
  photographyStatus: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Inventory Batch `photography_status`.
 * It maps `photography_status` to certain style and pass to `StatusBadge`.
 * @param {string} photography_status Merchant Inbound Inventory Batch Item.
 */
const MerchantInventoryBatchItemPhotographyStatusBadge = ({ photographyStatus }) => {

  const colorMap = {
    [PHOTOGRAPHY_STATUS.PENDING]   : 'warning',
    [PHOTOGRAPHY_STATUS.COMPLETED] : 'success'
  }

  const color = colorMap[photographyStatus]

  return <StatusBadge color={ color } label={ photographyStatus } />
}

MerchantInventoryBatchItemPhotographyStatusBadge.propTypes = propTypes

export default MerchantInventoryBatchItemPhotographyStatusBadge
